import React from "react";
import "../../stylesheets/screen.css.scss";
import SubHeader from "../../components/SubHeader/SubHeader";
import Layout from "../../components/Layout/Layout";
import TryOut from "../../components/TryOut";
import {useMyContext} from "../../context/MyContext";
import * as Constants from "../../constants/Constants";


const SingleApiPage = ()=>{
  const {showTryOut} = useMyContext();
  return (
    <>
      {/* <SubHeader component={Constants.Values.SINGLE_API}/> */}
      {showTryOut?<TryOut/>:null}
      <Layout component={"Single API"} />
    </>
  );
};

export default SingleApiPage;
